import React, { useState } from 'react'
import { Table } from 'reactstrap';
import moment from "moment/moment";
import { Pagination } from '../../../../Components/Common/Pagination';
import "../../style.scss";

export default function VehicleInsuranceTable({ InsuranceTableData }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);

    return (
        <div className="maintanences-table">
            <Table hover responsive>
                <thead>
                    <tr>
                        <th>Sr.no</th>
                        <th>Type</th>
                        <th>Cost</th>
                        <th>Performed On</th>
                        <th>Next Due Date</th>
                        <th>Notes</th>
                        <th>File</th>
                    </tr>
                </thead>


                <tbody>
                    {InsuranceTableData?.length ? (
                        InsuranceTableData?.map((element, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="action-icons">
                                        <span>{(currentPage - 1) * pageSize + index + 1}</span>
                                    </div>
                                </td>
                                <td>{element.vehicle_maintenance_type_data.name || "-"}</td>
                                <td>
                                    {element.cost || "-"}
                                </td>
                                <td>{moment(element.performed_on).format("D MMM YYYY") || "-"}</td>
                                <td>{moment(element.next_due_date).format("D MMM YYYY") || "-"}</td>
                                <td title={element.notes}>
                                    {element.notes?.length > 10
                                        ? `${element.notes.slice(0, 10)}...`
                                        : element.notes || "-"}
                                </td>
                                <td>
                                    {element.files?.length ? (
                                        <ul className="maintenance-files-list">
                                            {element.files.map((fileItem) => (
                                                <li key={fileItem.id}>
                                                    <a
                                                        href={`http://dna-django.projectanddemoserver.com/media/maintenance_files/${element.id}/${fileItem.file}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {(fileItem.file).slice(0, 10) + "..." + (fileItem.file).slice(-3)}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center" colSpan={9}>
                                <h3>No Insurance Found</h3>
                            </td>
                        </tr>
                    )}
                </tbody>

            </Table>

            {InsuranceTableData?.length > 0 && (
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    totalItems={InsuranceTableData?.length || 0}
                />
            )}

        </div>
    )
}
